export default {
  font1: 'Raleway, cursive',
  font2: '"Open Sans", sans-serif',

  red: '#FFDB00',
  tint: '#F1FAEE',
  turkis: '#A8DADC',
  blue: '#0A1659',
  marin: '#1D3557',
  white: '#FFFFFF'
};
